import React from 'react';
import logo from '../assets/Espressiflogo.svg';

const PrivacyPolicy = () => {
    return ( 
        <div className="container">
            <div className="row">
                <div className="one-half column" style={{marginTop: "5%"}}>
                    <img src={logo}
                        className="privacy-policy-logo"
                        alt="espressif-logo"/>
                    <h5><br />ESP Alexa - Privacy Policy</h5>
                    <br />
                    <div id="intro" className="mt-3">
                        <p>
                            In this Privacy Policy (“Policy”), we, Espressif and our subsidiaries, provide information
                            about how we collect, use, process and transfer personal data. For this Policy, we use the
                            term “personal data” broadly to cover the many privacy and data protection laws applicable
                            to us; “personal data” means information related to an identified natural person or that
                            could reasonably be used (by itself or in combination with other data reasonably available)
                            to identify a natural person.
                        </p>
                        <p>
                            <h5>Scope</h5>
                            This Policy applies to our website whose direct link is posted in this Policy or referred to
                            within this Policy (collectively the “Services”). This Policy covers only data collected
                            through the Services and not any other data collection or processing, including, without
                            limitation, data collection practices of other services that maintain their own, separate
                            privacy policies.
                        </p>
                        <p>
                            <h5>Types of Data and Collection Methods</h5>
                            We collect your email address(es) related to the business you present when you register on
                            https://github.com/espressif/esp-va-sdk.
                        </p>
                        <p>
                            <h5>Collection Purposes, Use of Data</h5>
                            We collect and process personal data about you with your consent and/or as necessary to
                            provide the products you use, operate our business, meet our contractual and legal
                            obligations, protect the security of our systems and our customers, or fulfil other
                            legitimate interests. The purposes for which we collect and use data is for our records.
                        </p>
                        <p>
                            <h5>Where We Store and Process Data</h5>
                            We store the email addresses in Amazon Web Services (AWS) servers in United States of
                            America. The email addresses are stored as we provide only a limited number of certificates
                            to each user to prevent unfair usage.
                        </p>
                        <p>
                            <h5>Your Choices</h5>
                            You have the right to withdraw your consent and stop any future use of your data. You can
                            exercise your right to obtain information and access to the data, to rectify them in case of
                            inaccurate data related to you and to delete the data when conditions are fulfilled by
                            sending an email to sales@espressif.com.
                        </p>
                        <p>
                            <h5>Security</h5>
                            We ensure your data remains secure and confidential, including certain processing carried
                            out by sub-processor.
                            For this purpose, the appropriate technical and organizational measures are in place to
                            prevent the loss, misuse, alteration and deletion of your personal data. These measures are
                            adapted according to the level of sensitivity of this processed data and the level of risk
                            that the processing or implementation of it presents.
                        </p>
                        <p>
                            <h5>Modification of the personal data protection notice</h5>
                            This Privacy Notice is subject to change.
                        </p>
                        <p>
                            <h5>Contact Us</h5>
                            If you need to get in touch about accessing your data stored on our servers, or for any
                            another complaint or query, please reach out to us at sales@espressif.com.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
} 

export default PrivacyPolicy;